var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import { autodetect, map, primitive, withDefault } from '../../../utils/serializr/serializr';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
export class EntityStore {
    parent;
    entityName;
    // @observable.shallow flexMap: ObservableMap<string | number | boolean>;
    flexMap = observable.map();
    objectIdOfSavingEntity;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get entity() {
        return this.parent;
    }
    /*
    @memoize
    get id() {
      return nanoid(6);
    }
  */
    static get serializeInfo() {
        return {
            props: {
                flexMap: withDefault(map(autodetect()), {}),
                entityName: withDefault(primitive, ''),
                objectIdOfSavingEntity: withDefault(primitive, 'master'),
            },
        };
    }
}
__decorate([
    editable()
], EntityStore.prototype, "entityName", void 0);
__decorate([
    editable('shallow')
], EntityStore.prototype, "flexMap", void 0);
__decorate([
    editable()
], EntityStore.prototype, "objectIdOfSavingEntity", void 0);
__decorate([
    memoize
], EntityStore, "serializeInfo", null);
